type TranslationObject = {
  [key: string]: string | TranslationObject;
};

type Translations = {
  [locale: string]: TranslationObject;
};

const errorMessage = (key: string, locale: string): string =>
  "Invalid translation key " + key + " for locale " + locale;

export const t = (key: string): string | undefined => {
  const i18nStore = useI18nStore();
  const storyVersionStore = useStoryVersionStore();

  const strings: Translations =
    storyVersionStore.storyVersion.data.project.strings;

  const locale = i18nStore.locale;

  const keys = key.split(".");

  let currentObject: TranslationObject | string = strings[locale];

  for (const k of keys) {
    if (typeof currentObject === "string" || !(k in currentObject)) {
      const e = errorMessage(key, locale);
      console.error(e);
      return e;
    }
    currentObject = currentObject[k];
  }

  if (typeof currentObject === "string") {
    return currentObject;
  }

  const e = errorMessage(key, locale);
  console.error(e);
  return e;
};

export const i = (object: TranslationObject): string => {
  const i18nStore = useI18nStore();

  if (object.hasOwnProperty(i18nStore.locale)) {
    return object?.[i18nStore.locale] as string;
  }
  return "";
};
